import { Form } from "antd";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { ActionResult, Query } from "../../common/hooks/useApi";
import useUsuariosAPI, { Usuario } from "../../usuarios/useUsuariosAPI";
import { FiltroInfraccionesRef } from "../components/FiltroInfracciones";
import useInfraccionesAPI from "../hooks/useInfraccionesAPI";


export default () => {

    const api = useInfraccionesAPI();
    const renombradoresApi = useUsuariosAPI();
    const [query, setQuery] = useState<Query>();
    const [total, setTotal] = useState<number | undefined>();
    const [renombradoresResponse, setRenombradoresResponse] = useState<ActionResult<Usuario[]>>();
    const [loadingForm, setLoadingForm] = useState(false);
    const filtroInfraccionesRef = useRef<FiltroInfraccionesRef>(null);

    const onSubmit = async (values: any) => {
        setLoadingForm(true);
        //await api.assignPending(values.RenombradorId,query);
        await filtroInfraccionesRef.current?.loadTotal();
        setLoadingForm(false);
    };

    useEffect(() => {
        renombradoresApi
            .list({ $filter: ["Role/Nombre eq 'Renombrador'"], $orderby: ["Apellido desc"] })
            .then(setRenombradoresResponse);
    }, []);

    return (<></>);
    /*
    return (
        <MainLayout title="Asignar infracciones a renombrar">

            <StyledForm onFinish={onSubmit}>
                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    name="RenombradorId"
                    required
                    label="Renombrador">
                    <Select
                        showSearch
                        optionFilterProp="children"
                        loading={!renombradoresResponse}
                        allowClear>
                        {renombradoresResponse?.data?.value.map(usuario => <Select.Option value={usuario.Id} key={usuario.Id}>{usuario.Apellido} {usuario.Nombre}</Select.Option>)}
                    </Select>
                </Form.Item>
                <Button disabled={!total || total == 0} loading={loadingForm} htmlType="submit" type="primary">Asignar</Button>
            </StyledForm>

            <FiltroInfracciones
                count={api.getPendingCount}
                ref={filtroInfraccionesRef}
                onChange={(query, count) => {
                    setQuery(query);
                    setTotal(count);
                }}
            />

        </MainLayout>
    );*/
};